import { PermissionMap } from '../base/permission-map';
import { FlattenedPermission } from '../base/flattened-permission';

export class EmployerPermissionMap extends PermissionMap {
  public map: Map<number, FlattenedPermission> = new Map<number, FlattenedPermission>();

  constructor() {
    super();
    this.map.set(2001, new FlattenedPermission('viewEmployeesTable'));
    this.map.set(2002, new FlattenedPermission('createEmployees'));
    this.map.set(2003, new FlattenedPermission('viewEmployeeDetails'));
    this.map.set(2004, new FlattenedPermission('viewEmployeeFullSin'));
    this.map.set(2005, new FlattenedPermission('editEmployeeEmploymentHistory'));
    this.map.set(2006, new FlattenedPermission('viewRemittances'));
    this.map.set(2007, new FlattenedPermission('createEditRemittances'));
    this.map.set(2008, new FlattenedPermission('viewRemittanceDetails'));
    this.map.set(2009, new FlattenedPermission('viewEmployerUsersTable'));
    this.map.set(2010, new FlattenedPermission('createEmployerUsers'));
    this.map.set(2011, new FlattenedPermission('viewEmployerUserDetails'));
    this.map.set(2012, new FlattenedPermission('editEmployerUserDetails'));
    this.map.set(2013, new FlattenedPermission('viewEmployerPlan'));
  }
}
